import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UsernameService {
  private username: string | null | undefined; // null implies anonymous user
  private org: string | undefined;
  private reportOwner: string | undefined;

  constructor() {}

  getUser() {
    return this.username;
  }

  getOrg() {
    return this.org;
  }

  getReportOwner() {
    return this.reportOwner;
  }

  setUser(username: string | null) {
    this.username = username;
  }

  setOrg(username: string) {
    this.org = username;
  }

  setReportOwner(username: string) {
    this.reportOwner = username;
  }
}
